<template>
  <div class="addr-box" style="padding: 0 22px;">
    <van-form :show-error-message="false" validate-trigger="onChange" @submit="submit" @failed="failed">
      <div class="title-info flex-sb" @click="handleOpenSearch">
        <div style="flex: 1;overflow: hidden;">
          <div class="address-title">{{ mapCenterInfo.title }}</div>
          <span class="details-address">{{mapCenterInfo.detailedAddress}}</span>
        </div>
        <span class="update-address-btn">
          更改地址
          <i class="iconfont icon-qianjin" style="font-size: 10px;color: #C9C2BB;margin-left: 2px;"></i>
        </span>
      </div>
      <van-cell-group inset :border="false">
        <div class="input-box">
          <van-field
            v-model.trim="form.remark"
            label="详细地址"
            name="详细地址"
            placeholder="如：1栋2206"
            class="input"
            @blur="formChange"
          />
        </div>
        <div class="input-box">
          <van-field
            v-model.trim="form.realName"
            label="联系人"
            name="姓名"
            placeholder="姓名"
            class="input"
            style="width: 348px;"
            :rules="[{ required: true, message: '请填写姓名' }]"
            @blur="formChange"
          />
          <van-field
            v-model.trim="form.phoneNumber"
            name="手机/座机"
            placeholder="手机/座机"
            class="input"
            :rules="[
              { required: true, message: '请填写手机/座机' },
              { pattern: /^((0\d{2,3}-\d{7,8})|(1\d{10})|(\d{7,8}))$/, message: '请填写正确的手机/座机' },
            ]"
            @blur="formChange"
          />
        </div>
        <div class="input-box">
           <van-field
            v-model="form.factoryName"
            label="工厂名称"
            name="工厂名称"
            placeholder="工厂名称"
            class="input"
            @blur="formChange"
          />
        </div>
      </van-cell-group>
      <van-button 
        round block 
        type="warning" 
        color="linear-gradient(129deg, #F1892E 0%, #F1BC3F 100%)" 
        native-type="submit" 
        class="footer-button"
      >{{$route.query.id?'修改地址':'添加地址'}}</van-button>
    </van-form>
  </div>
</template>

<script>
import { Image , Field , Cell , CellGroup , Form , RadioGroup, Radio , Button , Toast  } from 'vant';
export default {
  name:'dispatch-address-info',
  props:['mapCenterInfo','openSearch','queryParams'],
  components:{ 
    [Image.name]: Image,
    [Form.name]: Form,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button,
    [Toast.name]: Toast,
   },
  data(){
    return {
      form:{
        realName:'',
        phoneNumber:'',
        factoryName:'',
        remark:'',
      }
    }
  },
  watch:{
    queryParams:{
      handler(val){
        this.form = {
          realName:val.realName,
          phoneNumber:val.phoneNumber,
          remark:val.remark,
          factoryName:val.factoryName
        }
      },
      deep:true,
      immediate:true
    }
  },
  methods:{
    formChange(){
      this.$emit('update:queryParams',{
        ...this.queryParams,
        ...this.deepClone(this.form)
      })
    },
    handleOpenSearch(){
      this.$emit('update:openSearch',true);
    },
    submit(){
      let { title , latitude , longitude } = this.queryParams;
      if(!title || !latitude || !longitude || title === '移动以获取位置') return Toast.fail('移动以获取位置');
      window.uni.postMessage({
        data: this.queryParams
      });
      window.uni.navigateBack({
				delta:1
			})
    },
    failed({ errors }){
      Toast.fail(errors[0].message);
    }
  }
}
</script>

<style scoped lang="scss">
  .addr-box {
      background-color: #FFF;
      box-sizing: border-box;
      * {
        color: #130A01;
      }
      .van-form {
        .van-cell-group {
          margin: 0;
        }
        .title-info {
          overflow: hidden;
          padding: 12px 16px;
          margin: 16px 0;
          background-color: #F8F8F8;
          overflow: hidden;
          .details-address {
            font-size: 12px;
            line-height: 20px;
            color: #85807B;
          }
          .address-title {
            font-size: 18px;
            font-weight: bold;
            line-height: 26px;
            color: #3D3833;
          }
          .update-address-btn {
            flex-shrink: 0;
            margin-left: 13px;
            height: 24px;
            background-color: #FFF;
            border-radius: 2px;
            overflow: hidden;
            border: 1px solid #F5F1EF;
            font-size: 12px;
            line-height: 24px;
            padding: 0 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            counter-reset: #3D3833;
          }
        }
        .group-addr {
          padding: 0;
          width: auto;
          ::v-deep .van-radio__label {
            font-size: 14px;
            line-height: 30px;
          }
        }
        .input-box {
          height: 36px;
          overflow: hidden;
          background-color: #F5F5F5;
          border-radius: 6px;
          display: flex;
          margin-bottom: 16px;
          .input {
            background-color: #F5F5F5;
            height: 36px;
            line-height: 0;
            font-size: 16px;
          }
        }
        .footer-button {
          height: 44px;
          box-sizing: border-box;
          margin-bottom: 16px;
          background: #EC892E;
          border-radius: 4px;
          font-size: 16px;
          user-select: none;
          padding: 0 24px;
          * {
            color: #FFF;
          }
        }
      }
    }
    ::v-deep .van-field {
      align-items: center;
      .van-field__label {
        width: auto;
        font-size: 16px;
        line-height: 24px;
        display: flex;
        align-items: center;
        color: #1E1E1E;
      }
      .van-field__value {
        font-size: 16px;
        line-height: 24px;
      }
    }
</style>